import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ImageGalleryProps {
  images: string[];
}
const ImageGallery: React.FC<ImageGalleryProps> = ({
  images
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const handlePrevious = () => {
    setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const handleNext = () => {
    setCurrentImageIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const handleThumbnailClick = (index: number) => {
    setCurrentImageIndex(index);
  };
  if (images.length === 0) {
    return <div className="bg-gray-200 h-96 flex items-center justify-center" data-id="element-153">
        No images available
      </div>;
  }
  return <div className="space-y-4" data-id="element-154">
      <div className="relative h-96 overflow-hidden rounded-lg" data-id="element-155">
        <img src={images[currentImageIndex]} alt={`Property image ${currentImageIndex + 1}`} className="w-full h-full object-cover" data-id="element-156" />
        <button onClick={handlePrevious} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md" aria-label="Previous image" data-id="element-157">
          <ChevronLeftIcon className="h-6 w-6 text-gray-800" data-id="element-158" />
        </button>
        <button onClick={handleNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md" aria-label="Next image" data-id="element-159">
          <ChevronRightIcon className="h-6 w-6 text-gray-800" data-id="element-160" />
        </button>
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white/80 px-3 py-1 rounded-full text-sm font-medium" data-id="element-161">
          {currentImageIndex + 1} / {images.length}
        </div>
      </div>
      <div className="flex space-x-2 overflow-x-auto pb-2" data-id="element-162">
        {images.map((image, index) => <button key={index} onClick={() => handleThumbnailClick(index)} className={`flex-shrink-0 w-20 h-20 rounded-md overflow-hidden border-2 ${index === currentImageIndex ? 'border-blue-600' : 'border-transparent'}`} data-id="element-163">
            <img src={image} alt={`Thumbnail ${index + 1}`} className="w-full h-full object-cover" data-id="element-164" />
          </button>)}
      </div>
    </div>;
};
export default ImageGallery;